import axios from 'axios';

interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export async function validateApiKey(provider: string, apiKey: string): Promise<ValidationResult> {
  try {
    switch (provider) {
      case 'openai': {
        const response = await axios.get('https://api.openai.com/v1/models', {
          headers: {
            'Authorization': `Bearer ${apiKey}`,
            'Content-Type': 'application/json'
          },
          validateStatus: (status) => true // Permite que o axios retorne a resposta mesmo com erro
        });

        if (response.status !== 200) {
          return {
            isValid: false,
            error: 'Chave da OpenAI inválida'
          };
        }

        return { isValid: true };
      }

      case 'gemini': {
        const response = await axios.get(
          `https://generativelanguage.googleapis.com/v1beta/models?key=${apiKey}`,
          {
            headers: {
              'Content-Type': 'application/json'
            },
            validateStatus: (status) => true
          }
        );

        if (response.status !== 200) {
          return {
            isValid: false,
            error: 'Chave do Google Gemini inválida'
          };
        }

        return { isValid: true };
      }

      case 'anthropic': {
        const response = await axios.get('https://api.anthropic.com/v1/models', {
          headers: {
            'x-api-key': apiKey,
            'anthropic-version': '2023-06-01',
            'Content-Type': 'application/json',
            'anthropic-dangerous-direct-browser-access': 'true',
          },
          validateStatus: (status) => true
        });

        if (response.status !== 200) {
          return {
            isValid: false,
            error: 'Chave da Anthropic inválida'
          };
        }

        return { isValid: true };
      }

      default:
        return {
          isValid: false,
          error: 'Provedor inválido'
        };
    }
  } catch (error) {
    // Se houver erro de rede ou outro erro não relacionado à validação
    if (axios.isAxiosError(error)) {
      return {
        isValid: false,
        error: error.response?.data?.error?.message || 
              (provider === 'openai'
                ? 'Erro ao validar chave da OpenAI'
                : provider === 'anthropic'
                  ? 'Erro ao validar chave da Anthropic'
                  : 'Erro ao validar chave do Google Gemini')
      };
    }

    return {
      isValid: false,
      error: 'Erro ao validar a chave de API'
    };
  }
} 